"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/switch/style/css");

var _switch = _interopRequireDefault(require("antd/es/switch"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/col/style/css");

var _col = _interopRequireDefault(require("antd/es/col"));

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

require("antd/es/typography/style/css");

var _typography = _interopRequireDefault(require("antd/es/typography"));

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

require("antd/es/list/style/css");

var _list = _interopRequireDefault(require("antd/es/list"));

require("antd/es/select/style/css");

var _select = _interopRequireDefault(require("antd/es/select"));

var _icons = _interopRequireWildcard(require("@ant-design/icons"));

var _ = _interopRequireWildcard(require("lodash"));

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactInfiniteScroller = _interopRequireDefault(require("react-infinite-scroller"));

var _reactRedux = require("react-redux");

var _uuid = _interopRequireDefault(require("uuid"));

var _Toolbar = _interopRequireDefault(require("../../../components/inbox/Toolbar"));

var _QnaDetailCard = _interopRequireDefault(require("../../../components/qna/QnaDetailCard"));

var _QnaFormContainer = _interopRequireDefault(require("../../../components/qna/QnaFormContainer"));

var _SearchInput = _interopRequireDefault(require("../../../components/search/SearchInput"));

var _api = require("../../../redux/api/api.types");

var _forum = require("../../../redux/forum/forum.types");

var _qna = require("../../../redux/qna/qna.types");

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

var _topic = require("../../../redux/topics/topic.types");

require("./qna.scss");

var _Username = _interopRequireDefault(require("../../../components/username/Username"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Option
} = _select.default;
const {
  Item
} = _list.default;
const {
  confirm
} = _modal.default;
const {
  Paragraph
} = _typography.default;

const IconText = ({
  type,
  text
}) => /*#__PURE__*/_react.default.createElement("span", {
  className: "hmp-qna-icon"
}, /*#__PURE__*/_react.default.createElement(_icons.default, {
  type: type,
  style: {
    marginRight: 8
  }
}), text);

const previewLength = Number.MAX_SAFE_INTEGER;

class QnaLandingPage extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentId: -1,
      searchTerm: '',
      showDeleted: false,
      showOnlyUnanswered: false,
      showOnlyFlagged: false,
      pageSize: 10,
      pageNumber: 0,
      viewForm: false,
      selectedExpertId: undefined
    };
    this.infiniteScrollContainerKey = '';

    this.renderDate = value => {
      if (!value) {
        return 'N/a';
      }

      return (0, _moment.default)(value).calendar();
    };

    this.allcaps = s => s.toUpperCase();

    this.search = e => {
      this.setState({
        searchTerm: e.target.value
      });
    };

    this.debouncedHandleSearchChange = undefined;

    this.handleSearchChange = event => {
      if (!this.debouncedHandleSearchChange) {
        this.debouncedHandleSearchChange = _.debounce(() => {
          this.reinitializeAndSearch();
        }, 600);
      }

      this.setState({
        searchTerm: event.target.value,
        showOnlyFlagged: false
      });
      this.debouncedHandleSearchChange();
    };

    this.reinitializeAndSearch = () => {
      const {
        studyId,
        loadQnaPosts,
        clearQnaPosts
      } = this.props;
      const {
        pageSize,
        searchTerm,
        showDeleted,
        showOnlyUnanswered
      } = this.state;
      this.infiniteScrollContainerKey = (0, _uuid.default)();
      clearQnaPosts();
      loadQnaPosts({
        studyId,
        pageNumber: 0,
        query: searchTerm,
        pageSize,
        previewLength,
        includeDeleted: showDeleted,
        answers: showOnlyUnanswered ? 'unansweredOnly' : 'all'
      });
      this.setState({
        loading: true,
        pageNumber: 0
      });
    };

    this.onShowDeletedChange = checked => {
      this.setState({
        showDeleted: checked,
        showOnlyFlagged: false
      });
      setTimeout(this.reinitializeAndSearch, 5);
    };

    this.handleInfiniteLoad = pageNumber => {
      const {
        studyId,
        loadQnaPosts
      } = this.props;
      const {
        pageSize,
        searchTerm,
        showOnlyUnanswered,
        showDeleted
      } = this.state;
      this.setState({
        pageNumber
      });
      loadQnaPosts({
        studyId,
        query: searchTerm,
        pageNumber,
        pageSize,
        previewLength,
        includeDeleted: showDeleted,
        answers: showOnlyUnanswered ? 'unansweredOnly' : 'all'
      });
    };

    this.copyDeepLink = id => {
      const deepLink = `hmp://qna/${id}`;
      navigator.clipboard.writeText(deepLink).then(() => {
        _message2.default.success('Copied to clipboard!');
      }, () => {
        _message2.default.error('Failed to copy to clipboard.');
      });
    };

    this.displayQnaPost = currentId => {
      const {
        loadQnaPostById,
        resetActivitySelectedQnaPostId
      } = this.props;

      if (this.state.currentId !== currentId) {
        resetActivitySelectedQnaPostId();
        loadQnaPostById(currentId);
        this.setState({
          currentId
        });
      }
    };

    this.onShowOnlyFlaggedChange = checked => {
      this.setState({
        showOnlyFlagged: checked
      });

      if (checked) {
        const {
          loadFlaggedQnaContent,
          clearQnaPosts,
          studyId
        } = this.props;
        this.infiniteScrollContainerKey = (0, _uuid.default)();
        clearQnaPosts();
        loadFlaggedQnaContent(studyId);
        this.setState({
          showOnlyUnanswered: false,
          showDeleted: false,
          searchTerm: ''
        });
      } else {
        this.reinitializeAndSearch();
      }
    };

    this.onShowOnlyUnansweredChange = checked => {
      this.setState({
        showOnlyUnanswered: checked,
        showOnlyFlagged: false
      });
      setTimeout(this.reinitializeAndSearch, 5);
    };

    this.showQnaForm = () => {
      this.setState({
        viewForm: true
      });
    };

    this.closeQnaForm = () => {
      this.setState({
        viewForm: false
      });
    };

    this.deletePost = id => {
      const {
        currentId
      } = this.state;
      const {
        deleteQnaPost
      } = this.props;
      const setState = this.setState.bind(this);
      confirm({
        title: 'Are you sure you want to delete this post?',
        content: '',
        okText: 'Confirm',

        onOk() {
          if (currentId === id) {
            setState({
              currentId: -1
            });
          }

          deleteQnaPost(id);
        },

        onCancel() {}

      });
    };

    this.onSelectedExpertIdChange = id => {
      this.setState({
        selectedExpertId: id
      });
    };
  }

  componentDidMount() {
    const {
      studyId,
      loadQnaPosts,
      loadQnaTopics
    } = this.props;
    const {
      pageSize
    } = this.state;
    this.reinitializeAndSearch();
    loadQnaTopics();
  }

  componentWillReceiveProps(prevProps) {
    const {
      recentActivitySelectedQnaPostId,
      loadQnaPostById
    } = this.props;

    if (recentActivitySelectedQnaPostId) {
      loadQnaPostById(recentActivitySelectedQnaPostId);
      this.setState({
        currentId: recentActivitySelectedQnaPostId
      });
    }
  }

  render() {
    const {
      currentId,
      searchTerm,
      showDeleted,
      showOnlyUnanswered,
      showOnlyFlagged,
      pageNumber,
      pageSize,
      viewForm,
      selectedExpertId
    } = this.state;
    const {
      qnaPosts,
      loadQnaPostsStatus,
      experts
    } = this.props;
    let sortedQnaPosts = (qnaPosts || []).sort((a, b) => (0, _moment.default)(a.createDate).unix() - (0, _moment.default)(b.createDate).unix()).reverse();

    if (selectedExpertId && selectedExpertId > -1) {
      sortedQnaPosts = sortedQnaPosts.filter(post => post.adHocNotifications.some(notifications => notifications.userId === selectedExpertId));
    }

    let currentPost;

    if (currentId > -1) {
      currentPost = _.find(sortedQnaPosts, post => post.id === currentId);
    }

    const hasMore = (1 + pageNumber) * pageSize === sortedQnaPosts.length;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "hmp-forum-page"
    }, viewForm && /*#__PURE__*/_react.default.createElement(_QnaFormContainer.default, {
      visible: viewForm,
      closeHandler: this.closeQnaForm
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-qna-page-tab",
      key: this.infiniteScrollContainerKey
    }, /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 11,
      className: "hmp-qna-col"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-qna-list-header"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-qna-list-toolbar"
    }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
      title: "Ask an Expert",
      leftItems: [],
      rightItems: [/*#__PURE__*/_react.default.createElement(_button.default, {
        key: "createNewButton",
        type: "primary",
        onClick: e => {
          e.stopPropagation();
          this.showQnaForm();
        }
      }, "+ Add Post")]
    })), /*#__PURE__*/_react.default.createElement(_SearchInput.default, {
      className: "search-bar",
      id: "search-input",
      onChangeHandler: this.handleSearchChange,
      placeholder: "Search Posts",
      value: searchTerm
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "filter-items"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "filter"
    }, "Show Only Flagged", /*#__PURE__*/_react.default.createElement(_switch.default, {
      checked: showOnlyFlagged,
      onChange: this.onShowOnlyFlaggedChange
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "filter"
    }, "Show Deleted", /*#__PURE__*/_react.default.createElement(_switch.default, {
      checked: showDeleted,
      onChange: this.onShowDeletedChange
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "filter"
    }, "Show Only Unanswered", /*#__PURE__*/_react.default.createElement(_switch.default, {
      checked: showOnlyUnanswered,
      onChange: this.onShowOnlyUnansweredChange
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "dropdown-container"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "dropdown"
    }, "Assigned To:", /*#__PURE__*/_react.default.createElement(_select.default, {
      allowClear: true,
      className: "dropdown-box",
      placeholder: "Select an expert",
      value: selectedExpertId,
      onChange: this.onSelectedExpertIdChange
    }, experts === null || experts === void 0 ? void 0 : experts.map(expert => /*#__PURE__*/_react.default.createElement(Option, {
      key: `expert-option-${expert.id}`,
      value: expert.id
    }, `${expert.firstName} ${expert.lastName}`)))))), /*#__PURE__*/_react.default.createElement("div", {
      id: "infinite-scroll-container"
    }, /*#__PURE__*/_react.default.createElement(_reactInfiniteScroller.default, {
      initialLoad: false,
      pageStart: 0,
      loadMore: this.handleInfiniteLoad,
      hasMore: hasMore,
      useWindow: false
    }, /*#__PURE__*/_react.default.createElement(_list.default, {
      bordered: true,
      itemLayout: "vertical",
      size: "large",
      dataSource: sortedQnaPosts,
      renderItem: item => {
        const {
          id,
          favorites,
          thumbsups,
          comments,
          topic,
          question,
          answer,
          createDate,
          username,
          createdByParticipantId,
          answeredByUsername,
          deleteDate
        } = item;
        const commentCount = comments ? comments.length + comments.map(c => c.comments.length).reduce((sum, c) => sum + c, 0) : 0;
        let actions = [];
        actions = actions.concat([/*#__PURE__*/_react.default.createElement("span", {
          className: "hmp-qna-username"
        }, /*#__PURE__*/_react.default.createElement(_Username.default, {
          participantId: createdByParticipantId,
          username: username
        })), /*#__PURE__*/_react.default.createElement("span", {
          className: "hmp-qna-date"
        }, this.renderDate(createDate)), /*#__PURE__*/_react.default.createElement("span", {
          className: "hmp-qna-icon",
          key: "list-vertical-message"
        }, /*#__PURE__*/_react.default.createElement(_icons.MessageOutlined, {
          style: {
            marginRight: 8
          }
        }), commentCount), /*#__PURE__*/_react.default.createElement("span", {
          className: "hmp-qna-icon",
          key: "list-vertical-like-o"
        }, /*#__PURE__*/_react.default.createElement(_icons.LikeOutlined, {
          style: {
            marginRight: 8
          }
        }), thumbsups ? thumbsups.length : 0), /*#__PURE__*/_react.default.createElement("span", {
          className: "hmp-qna-icon",
          key: "list-vertical-star-o"
        }, /*#__PURE__*/_react.default.createElement(_icons.StarOutlined, {
          style: {
            marginRight: 8
          }
        }), favorites ? favorites.length : 0), /*#__PURE__*/_react.default.createElement("a", {
          title: "Copy deep link to clipboard",
          className: "qna-action",
          onClick: e => {
            e.stopPropagation();
            this.copyDeepLink(id);
          }
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "far fa-link"
        }))]);
        const tags = [];

        if (deleteDate) {
          tags.push( /*#__PURE__*/_react.default.createElement("span", {
            title: (0, _moment.default)(deleteDate).calendar(),
            className: "post-tag-bubble deleted"
          }, "DELETED"));
        }

        return /*#__PURE__*/_react.default.createElement(Item, {
          key: `qna-post-${id}`,
          onClick: e => this.displayQnaPost(id),
          actions: actions
        }, /*#__PURE__*/_react.default.createElement(Item.Meta, {
          title: /*#__PURE__*/_react.default.createElement(Paragraph, {
            style: {
              color: 'black'
            },
            ellipsis: {
              rows: 2,
              expandable: false
            }
          }, `Q: ${question}`)
        }), /*#__PURE__*/_react.default.createElement(Paragraph, {
          className: "qna-post-answer",
          ellipsis: {
            rows: 2,
            expandable: false
          }
        }, answer ? /*#__PURE__*/_react.default.createElement("div", {
          className: "answerContainer"
        }, "A:", ' ', /*#__PURE__*/_react.default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: answer
          }
        })) : '(Unanswered)'), /*#__PURE__*/_react.default.createElement("div", {
          className: "hmp-qna-topic-container"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "signature"
        }, answeredByUsername), tags, /*#__PURE__*/_react.default.createElement("span", {
          className: "hmp-qna-topic"
        }, this.allcaps(topic))));
      }
    })))), /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 11,
      className: currentId === -1 ? 'hmp-qna-col-empty' : 'hmp-qna-col-post'
    }, currentPost && /*#__PURE__*/_react.default.createElement(_QnaDetailCard.default, {
      post: currentPost,
      deleteQnaPost: this.deletePost
    }))));
  }

}

const mapStateToProps = state => {
  return {
    qnaPosts: selectors.getQnaPosts(state),
    studyId: selectors.getRequestedStudyId(state),
    arms: selectors.getRequestedStudyStudyArms(state),
    loadQnaPostsStatus: selectors.loadQnaPostsStatus(state),
    // postCount: selectors.getQnaPostCount(state),
    recentActivitySelectedQnaPostId: state.ui.forums.recentActivity.selectedQnaPostId,
    experts: selectors.getExpertAdmin(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadQnaPosts: args => dispatch(_qna.getQnaPostsAsync.request(args)),
    // loadQnaPostCount: (studyId: number) => dispatch(getQnaPostCountAsync.request(studyId)),
    loadQnaPostById: id => dispatch(_qna.getQnaPostAsync.request(id)),
    loadQnaTopics: () => dispatch(_topic.loadQnaTopicsAsync.request()),
    loadFlaggedQnaContent: studyId => dispatch(_qna.getFlaggedQnaContentAsync.request(studyId)),
    deleteQnaPost: id => dispatch(_qna.deleteQnaPostAsync.request(id)),
    clearLoadStatus: type => dispatch((0, _api.clearStatus)(type)),
    clearQnaPosts: () => dispatch((0, _qna.clearQnaPosts)()),
    resetActivitySelectedQnaPostId: () => dispatch((0, _forum.resetRecentActivitySelectedQnaPostId)())
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(QnaLandingPage);

exports.default = _default;